import React from 'react'

export const Loading = () => {
  return (
    <div>
        <div class="flex items-center justify-center space-x-2 animate-bounce">
    <div class="w-8 h-8 bg-purple-300 rounded-full"></div>
    <div class="w-8 h-8 bg-purple-600 rounded-full"></div>
    <div class="w-8 h-8 bg-purple-900 rounded-full"></div>
</div>
    </div>
  )
}
